module.exports = ".loading_bar {\n  transition: 300ms;\n}\n/*# sourceMappingURL=src/app/header/loader/loader.component.css.map */"